/* eslint-disable @typescript-eslint/ban-ts-comment */
import { useDispatch, useSelector } from 'react-redux';
import Text from '@deprecated-ui/common/Text';
import auth from 'utils/auth';
import ConfirmationModal from './ConfirmationModal';
import slice, { selectors, thunks } from './slice';
import wlSlice, { selectors as wlSelectors } from '../slice';

const { actions } = slice;

function RemoveWatchlist() {
  const { modalVisible, selectedForModify } = useSelector(selectors);
  const { activeWatchlistId } = useSelector(wlSelectors);
  const dispatch = useDispatch();

  const loadAllWatchlist = () => {
    // @ts-ignore
    const { watchlist_id: wl } = auth.getUserAccess();

    dispatch(
      wlSlice.actions.handleChangeActiveWatchlist({
        selected: wl,
        name: 'All Watchlist',
      }),
    );
  };

  const onConfirmClick = async () => {
    const del = await dispatch(
      thunks.deleteCompanyWatchlist({ id: selectedForModify.watchlist_id }),
    );

    // @ts-ignore
    const { data } = del.payload;

    const isActive = selectedForModify.watchlist_id === activeWatchlistId;
    if (data && isActive) {
      loadAllWatchlist();
    }
  };

  const onCancelClick = () => {
    dispatch(
      actions.handleSelectForModify({
        modalType: 'none',
        selectedIndex: null,
      }),
    );
  };

  const title = 'Remove Watchlist Collection';
  const isModalVisible = modalVisible === 'delete';

  return (
    <ConfirmationModal
      isVisible={isModalVisible}
      onCancel={onCancelClick}
      onConfirm={onConfirmClick}
      title={title}
      isBlock
    >
      <Text padding="12px 16px">
        Are you sure want to remove &quot;{selectedForModify.name}&quot;?
      </Text>
    </ConfirmationModal>
  );
}

export default RemoveWatchlist;
